var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"framework"},[_c('qiankun',{staticStyle:{"height":"100%"},on:{"app-mounted":_vm.afterMounted,"app-unmounted":_vm.afterUnmounted,"uncaught-error":_vm.error}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }